import { useEffect, useRef, useState } from "react";

export const WA_URL =
  "https://wa.me/34614354669?text=Hola%2C%20tengo%20un%20restaurante%20y%20me%20gustar%C3%ADa%20ver%20c%C3%B3mo%20funciona%20Kanvia";
export const EMAIL = "jm@kanvia.eu";
export const WA_NUMBER = "+34 614 35 46 69";

export function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export function Reveal({ children, delay = 0, className = "" }) {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`rv${inView ? " in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}

export function Lines({ lines, className = "", as: Tag = "h2" }) {
  const [ref, inView] = useInView(0.25);
  return (
    <Tag ref={ref} className={className}>
      {lines.map((l, i) => (
        <span className="lm" key={typeof l === "string" ? l : `linea-${i}`}>
          <span
            className={`li${inView ? " on" : ""}`}
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            {l}
            {i < lines.length - 1 ? " " : null}
          </span>
        </span>
      ))}
    </Tag>
  );
}

export function SectionHead({ num, label, className = "" }) {
  const [ref, inView] = useInView(0.4);
  return (
    <div
      ref={ref}
      className={`sh${inView ? " in" : ""} ${className}`}
      data-testid={`section-head-${num}`}
    >
      <span className="sh-rule" aria-hidden="true" />
      <p className="sh-meta font-mono">
        <span>{num}</span>
        <span aria-hidden="true">·</span>
        <span>{label}</span>
      </p>
    </div>
  );
}

export function Logo({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      stroke="currentColor"
      strokeWidth="11"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M32 16 V104" />
      <path d="M76 46 L41 68 L74 104" />
      <path d="M90 48 C102 62 102 80 90 94" opacity=".5" />
    </svg>
  );
}

export function ArcMark({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      stroke="currentColor"
      strokeWidth="11"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M90 48 C102 62 102 80 90 94" />
    </svg>
  );
}

export function WaIcon({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3.4c-4.8 0-8.6 3.7-8.6 8.2 0 1.6.5 3.1 1.4 4.4L3.4 20.6l4.8-1.3c1.2.7 2.5 1 3.8 1 4.8 0 8.6-3.7 8.6-8.2S16.8 3.4 12 3.4Z" />
      <path d="M9.1 8.3c-.3 0-.7.2-.9.6-.5.9-.4 2.3.6 3.8 1 1.5 2.4 2.6 3.9 3 .7.2 1.4 0 1.8-.5.2-.3.2-.7 0-1l-1-1c-.2-.2-.5-.3-.8-.1l-.6.4c-.9-.4-1.7-1.2-2.1-2.1l.4-.6c.2-.3.2-.6 0-.8l-1-1.1c-.1-.2-.2-.4-.3-.4Z" />
    </svg>
  );
}

export function PhoneIcon({ className = "" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5.2 3.6h3.6l1.5 4.4-2.2 1.7a12.8 12.8 0 0 0 5.6 5.6l1.7-2.2 4.4 1.5v3.6a1.6 1.6 0 0 1-1.7 1.6C9.5 19.3 4.7 14.5 4.2 5.3a1.6 1.6 0 0 1 1-1.7Z" />
    </svg>
  );
}

export function Img({ src, alt, name, className = "", eager = false }) {
  const [err, setErr] = useState(false);
  if (err) {
    return (
      <div className={`img-fallback ${className}`} role="img" aria-label={alt}>
        <span className="font-mono">{name}</span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={eager ? "high" : "auto"}
      onError={() => setErr(true)}
      className={`foto ${className}`}
    />
  );
}
